import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { inviteService } from "../../services/invite.service";
import { walletService } from "../../services/wallet.service";
import walletType from "./walletTypes";

/**
 * GetAllInvites
 *
 */
export const getAllWallets = () => async (dispatch) => {
  try {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: true,
    });
    const response = await walletService.getAllWallets();
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType[" GET_ALL_WALLETS"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};

/**
 * StoreInvites
 * @param {object} payLoad{ name:"gaming",types: skilled}
 * @returns {void}
 * */

export const storeWallet = (payLoad, business) => async (dispatch) => {
  try {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: true,
    });
    const response = await walletService.storeWallet({
      ...payLoad,
    });
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["STORE_WALLET"],
      payLoad: response,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Delete invite
 * @param {object} payLoad{ id:"22"}
 * @returns {void}
 * */
export const deleteWallet = (payLoad) => async (dispatch) => {
  try {
    const response = await walletService.deleteWallet({
      ...payLoad,
    });
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["DELETE_WALLET"],
      payLoad: response,
    });
    successHandler(response, true);
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};

/**
 * Edit invite
 * @param {object} payLoad {id:"22"}
 * @returns {void}
 * */
export const editInvite = (payLoad) => async (dispatch) => {
  try {
    const response = await inviteService.editInvite({
      ...payLoad,
    });
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["EDIT_INVITE"],
      payLoad: response,
    });
    successHandler(response, true);
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};
/**
 * Edit invite
 * @param {object} payLoad {search:"ogwugo"}
 * @returns {void}
 * */
export const searchInvites = (payLoad) => async (dispatch) => {
  try {
    const response = await inviteService.searchInvites({
      ...payLoad,
    });
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["SEARCH_INVITE"],
      payLoad: response,
    });
    successHandler(response, true);
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};
/**
 * Edit invite
 * @param {object} payLoad {company_id :"7b3e58e0-b68c-498d-b8d5-82198ef6d481"}
 * @returns {void}
 * */
export const filterInvites = (payLoad) => async (dispatch) => {
  try {
    const response = await inviteService.filterInvites({
      ...payLoad,
    });
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["FILTER_INVITES"],
      payLoad: response,
    });
    successHandler(response, true);
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};
/**
 * Show invite
 * @param {object} payLoad {properties:1}
 * */
export const showWallet = (payLoad) => async (dispatch) => {
  try {
    const response = await walletService.showWallet({
      ...payLoad,
    });

    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["SHOW_WALLET"],
      payLoad: response,
    });
    successHandler(response, true);
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};
/**
 * Show my wallets
 * @param {object} payLoad {properties:1}
 * */
export const showMyWallets = () => async (dispatch) => {
  try {
    const response = await walletService.showMyWallets();
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    dispatch({
      type: walletType["SHOW_MY_WALLET"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: walletType["LOADING_WALLETS"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
